import { cn } from "@/lib/utils";
import { useEffect, useRef, useState, ReactNode } from "react";
import { ArrowOpened } from "@/svg/static-pages/business-portfolio/exams-landing/arrow-opened";
import { ArrowClosed } from "@/svg/static-pages/business-portfolio/exams-landing/arrow-closed";

export const Accordion = ({
  items,
  active = false,
}: {
  items: { question: string; answer: string }[];
  active?: boolean;
}) => {
  return (
    <div
      className={cn(
        `hidden w-full flex-col gap-[24px] px-[24px] md:px-[208px]`,
        active && "flex",
      )}
    >
      {items.map((item, index) => (
        <AccordionItem key={index} title={item.question}>
          {/* {item.answer} */}
          <div dangerouslySetInnerHTML={{ __html: item.answer }}></div>
        </AccordionItem>
      ))}
    </div>
  );
};

const AccordionItem = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setTimeout(() => setIsOpen(false), 100);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`flex flex-col justify-center gap-[10px] rounded-[20px] bg-[#f5f6fa] p-[24px]`}
    >
      <div
        className={`flex cursor-pointer items-center justify-between gap-[10px] select-none`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div
          className={`text-left text-[20px] leading-[24px] font-semibold md:text-[24px] md:leading-[30.72px]`}
        >
          {title}
        </div>
        <button className={""}>
          {isOpen ? <ArrowOpened /> : <ArrowClosed />}
        </button>
      </div>
      <div
        className={cn(
          `[&_a}:text-remedium-blue hidden text-left text-[14px] leading-[17.92px] font-normal md:text-[16px] md:leading-[20.48px]`,
          isOpen && "block",
        )}
      >
        {children}
      </div>
    </div>
  );
};
